import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-menu',
  templateUrl: './student-menu.component.html',
  styleUrls: ['./student-menu.component.css']
})
export class StudentMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
